/**
 * CustomThemeCreator component allows users to customize the theme of the application
 * by selecting colors for various elements using the BlockPicker from react-color.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {Object} props.themeData - The current theme data containing colors for various elements.
 * @param {Function} props.handleThemeDataChange - The function to handle changes in the theme data.
 *
 * @example
 * const themeData = {
 *   menuBackground: "#ffffff",
 *   menuPageBackground: "#f0f0f0",
 *   menuTextColor: "#000000",
 *   menuHeaderTextColor: "#333333",
 *   menuHeaderColor: "#cccccc",
 *   sidenavColor: "#222222",
 *   sidenavTextColor: "#ffffff",
 *   sidenavHoverColor: "#444444"
 * };
 *
 * const handleThemeDataChange = (newThemeData) => {
 * };
 *
 * <CustomThemeCreator themeData={themeData} handleThemeDataChange={handleThemeDataChange} />
 */
import { BlockPicker } from "react-color";

const CustomThemeCreator = ({ themeData, handleThemeDataChange }) => {
  return (
    <div>
      <div className="custom-themes">
        <div className="theme-child">
          <p className="custom-theme-text">menu/profile background</p>
          <BlockPicker
            className="block-picker"
            color={themeData.menuBackground}
            onChange={(color) => {
              handleThemeDataChange({
                ...themeData,
                menuBackground: color.hex,
              });
            }}
          />
        </div>
        <div className="theme-child">
          <p className="custom-theme-text">menu page background</p>
          <BlockPicker
            className="block-picker"
            color={themeData.menuPageBackground}
            onChange={(color) => {
              handleThemeDataChange({
                ...themeData,
                menuPageBackground: color.hex,
              });
            }}
          />
        </div>
        <div className="theme-child">
          <p className="custom-theme-text">menu text color</p>
          <BlockPicker
            className="block-picker"
            color={themeData.menuTextColor}
            onChange={(color) => {
              handleThemeDataChange({ ...themeData, menuTextColor: color.hex });
            }}
          />
        </div>
        <div className="theme-child">
          <p className="custom-theme-text">menu header text color</p>
          <BlockPicker
            className="block-picker"
            color={themeData.menuHeaderTextColor}
            onChange={(color) => {
              handleThemeDataChange({
                ...themeData,
                menuHeaderTextColor: color.hex,
              });
            }}
          />
        </div>
        <div className="theme-child">
          <p className="custom-theme-text">menu header color</p>
          <BlockPicker
            className="block-picker"
            color={themeData.menuHeaderColor}
            onChange={(color) => {
              handleThemeDataChange({
                ...themeData,
                menuHeaderColor: color.hex,
              });
            }}
          />
        </div>
        <div className="theme-child">
          <p className="custom-theme-text">sidenav color</p>
          <BlockPicker
            className="block-picker"
            color={themeData.sidenavColor}
            onChange={(color) => {
              handleThemeDataChange({ ...themeData, sidenavColor: color.hex });
            }}
          />
        </div>
        <div className="theme-child">
          <p className="custom-theme-text">sidenav text color</p>
          <BlockPicker
            className="block-picker"
            color={themeData.sidenavTextColor}
            onChange={(color) => {
              handleThemeDataChange({
                ...themeData,
                sidenavTextColor: color.hex,
              });
            }}
          />
        </div>
        <div className="theme-child">
          <p className="custom-theme-text">sidenav hover color</p>
          <BlockPicker
            className="block-picker"
            color={themeData.sidenavHoverColor}
            onChange={(color) => {
              handleThemeDataChange({
                ...themeData,
                sidenavHoverColor: color.hex,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomThemeCreator;
